import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import UserLoginPage from '../Pages/LoginPage/login';
import ForgotPassPage from '../Pages/ForgotPassPage/forgot_password_page';
import ResetPassPage from '../Pages/ResetPassPage/reset_pass_page';
import SsoPage from '../Pages/LoginPage/sso_page';

class AuthSwitch extends React.Component {
  /* Esta é a primeira etapa após o construxctor para carregar este componente  */

  componentDidMount() {
    const token = window.localStorage.getItem('token');
    const pathname = window.location.pathname;

    // Lista de rotas exclusivas para quem NÃO está autenticado
    const publicRoutes = ['/login', '/forgot_password', '/reset_password', '/sso_page'];
    const isPublicRoute = publicRoutes.some(route => pathname.includes(route));

    // 1. UTILIZADOR AUTENTICADO: Tenta aceder ao /login ou rotas públicas
    if (token && (isPublicRoute || pathname === '/')) {
      window.location.href = '/agenda_digital';
      return;
    }

    // 2. UTILIZADOR NÃO AUTENTICADO: Tenta aceder a páginas privadas
    if (!token && !isPublicRoute) {
      window.location.href = '/login';
    }
  }

  render() {
    console.log('Login page')
    return (
      <Switch>
        <Route exact path="/" render={() => (<Redirect to="/agenda_digital" />)} />
        <Route exact path="/login" component={UserLoginPage} />
        <Route path="/forgot_password" component={ForgotPassPage} />
        <Route path="/reset_password" component={ResetPassPage} />
        <Route path="/sso_page" component={SsoPage} />
      </Switch>
    );
  }
}

export default AuthSwitch;
